import React, { useState } from 'react';

// import Downarrow from 'assets/icons/downArrow.svg';
import Inbox from 'assets/icons/inboxicon.svg';
import Draft from 'assets/icons/drafticon.svg';
import Junk from 'assets/icons/junkicon.svg';
import Sent from 'assets/icons/senticon.svg';
import Saved from 'assets/icons/savedicon.svg';
import Archive from 'assets/icons/archiveicon.svg';
import dislike from 'assets/icons/unfavouritIcon.svg';
import like from 'assets/icons/favouritIcon.svg';
import Spam1 from 'assets/icons/spamIcon1.svg';
import Spam2 from 'assets/icons/spamIcon2.svg';
import { ReactComponent as Settings } from 'assets/icons/settingsIcon2.svg';

import Inbox2 from 'assets/icons/inboxicon2.svg';
import Draft2 from 'assets/icons/drafticon2.svg';
import Junk2 from 'assets/icons/junkicon2.svg';
import Sent2 from 'assets/icons/senticon2.svg';
import Saved2 from 'assets/icons/savedicon2.svg';
import Archive2 from 'assets/icons/archiveicon2.svg';
import FolderIcon from 'assets/icons/folderIcon.svg';
import FolderIcon2 from 'assets/icons/folderIcon2.svg';

// import Schedulemeeting from '../components/Schedulemeeting';
import { NavLink } from 'react-router-dom';
import { useLocation } from 'react-use';
import SecondaryButton from 'components/secondaryButton';
import PrimaryButton from 'components/primaryButton';
import Createfoldermodel from '../components/createfolder';
import UseGetmails from '../hooks/useGetMails';
import useGetMailFolders from '../hooks/useGetMailFolders';
import UseGetMailsForFolder from '../hooks/useGetMailsForFolder';
import EmailSettings from '../components/EmailSettings';
import FolderPopover from '../components/FolderPopover';
import dayjs from 'dayjs';

const Navigation = ({ setMails, searchTerm, date, setIsLoading }) => {
  const [showfoldermodal, setShowfoldermodal] = useState(false);
  const [showSettingsmodal, setShowSettingsmodal] = useState(false);
  const [folder, setFolder] = useState();

  const location = useLocation();

  // console.log(location.pathname?.split("/")[3]);
  const Navitems = [
    /* {
      id: 2,
      icon: Downarrow,
      title: 'Folders',
      path: 'folders',
      icon2: Downarrow,
    }, */
    {
      id: 3,
      icon: Inbox,
      title: 'Inbox',
      path: '/app/mail/inbox',
      icon2: Inbox2,
    },
    {
      id: 4,
      icon: Draft,
      title: 'Drafts',
      path: '/app/mail/draft',
      icon2: Draft2,
      type: 'Draft',
    },
    {
      id: 6,
      icon: Sent,
      title: 'Sent mails',
      path: '/app/mail/sentmails',
      icon2: Sent2,
      type: 'Sent',
    },
    {
      id: 1,
      icon: like,
      title: 'Favorites',
      path: '/app/mail/favorites',
      icon2: dislike,
    },
    {
      id: 7,
      icon: Saved,
      title: 'Saved mails',
      path: '/app/mail/savedmails',
      icon2: Saved2,
    },
    {
      id: 5,
      icon: Junk,
      title: 'Deleted ',
      path: '/app/mail/deleted',
      icon2: Junk2,
      type: 'Deleted',
    },
    {
      id: 9,
      icon: Spam1,
      title: 'Junk mails ',
      path: '/app/mail/junk',
      icon2: Spam2,
      type: 'Junk',
    },

    {
      id: 8,
      icon: Archive,
      title: 'Archive',
      path: '/app/mail/archive',
      icon2: Archive2,
      type: 'Archive',
    },
  ];
  const folders = useGetMailFolders()?.data?.data?.map((folder) => {
    return {
      id: folder?.id,
      title: folder?.name,
      path: '/app/mail/' + folder?.name?.replaceAll(' ', '_').toLowerCase(),
      type: folder?.name,
      icon: FolderIcon,
      icon2: FolderIcon2,
      isfolder: true, // we are setting this unique key for the folder mails result =>we have to fetch the mails for custom folders
    };
  });

  const allFolders = folders ? Navitems.concat(folders) : Navitems;

  const active = allFolders.find((cat) => {
    return cat.path === location.pathname;
  });

  let getMails;

  if (folder?.isfolder) {
    getMails = UseGetMailsForFolder(folder?.id); //getting folder mails
  } else if (location.pathname === '/app/mail/favorites') {
    getMails = UseGetmails('favorites', dayjs(date).format('MM-YYYY')); //geeting mails by type
  } else if (
    location.pathname !== '/app/mail/inbox' ||
    location.pathname !== '/app/mail'
  ) {
    getMails = UseGetmails(
      location.pathname === '/app/mail/savedmails' ? 'saved' : active?.type,
      dayjs(date).format('MM-YYYY')
    ); //geeting mails by type
  }
  setIsLoading(getMails?.isLoading);
  setMails(getMails?.data?.data);
  return (
    <div className='   '>
      {allFolders?.map((each) => (
        <div key={each.title} onClick={() => setFolder(each)}>
          <NavLink
            to={each.path}
            className={({ isActive }) =>
              isActive && !searchTerm // if there is any search term then side bar should not be hilighted
                ? 'text-primary  text-base flex items-center gap-x-6 gap-y-2 p-1.5 bg-FCE8E6 xl:text-lg xl:p-2 2xl:text-xl 2xl:p-2.5 3xl:text-2xl 3xl:p-3.5'
                : 'text-202124  text-base flex items-center gap-x-6 gap-y-2 p-1.5 xl:text-lg xl:p-2 2xl:text-xl 2xl:p-2.5 3xl:text-2xl 3xl:p-3.5'
            }
          >
            {location.pathname === each.path && !searchTerm ? (
              <img
                src={each.icon}
                alt='icon'
                className='pl-8 2xl:w-14 3xl:w-16'
              />
            ) : (
              <img
                src={each.icon2}
                alt='icon'
                className='pl-8 2xl:w-14 3xl:w-16'
              />
            )}
            <p> {each.title}</p>

            {each?.isfolder && location.pathname === each.path && (
              <FolderPopover mail={each} />
            )}
          </NavLink>
        </div>
      ))}

      <div className='w-full mt-4 flex flex-col items-center bottom-4 gap-1 2xl:gap-3 2xl:bottom-6 3xl:gap-4'>
        <button
          onClick={() => setShowfoldermodal(true)}
          className='2xl:w-40 2xl:text-lg 3xl:w-44 3xl:text-xl'
        >
          <PrimaryButton>Create Folder</PrimaryButton>
        </button>

        <Createfoldermodel
          opened={showfoldermodal}
          setOpened={setShowfoldermodal}
        />

        <button
          onClick={() => setShowSettingsmodal(true)}
          className='2xl:w-40 2xl:text-lg 3xl:w-44 3xl:text-xl'
        >
          {/* <SecondaryButton>
            <Settings /> <p className='ml-2'>Email Settings</p>
          </SecondaryButton> */}
        </button>
        {/* <Schedulemeeting
          opened={showSettingsmodal}
          setOpened={setShowSettingsmodal}
        /> */}
        <EmailSettings
          opened={showSettingsmodal}
          setIsOpened={setShowSettingsmodal}
        />
      </div>
    </div>
  );
};

export default Navigation;
